import { useMutation, useQueryClient } from '@tanstack/react-query';

import useApi from '@/hooks/useApi/useApi';
import { queryKeys } from '@/lib/queryKeys';
import { Category } from '@/types/types';

export const useCreateCategory = () => {
  const queryClient = useQueryClient();
  const { axiosInstance } = useApi();

  return useMutation({
    mutationFn: async (newCategory: Partial<Category>) => {
      const { data } = await axiosInstance.post<Category>('/api/v1/categories', newCategory);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.categories._def });
    },
  });
};

export default useCreateCategory;
